<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Return Filter Module</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (airFilterSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Filter Type:</span>
            <select
              class="halfWidthInputField"
              #airFilterInput
              [class.invalidConfigurationSelection]="isInvalidSelection(airFilterSelection.Name)"
              (change)="selectionChanged(airFilterSelection, airFilterInput.value)"
              [value]="airFilterSelection.Value.toString()">
              @for (allowable of airFilterSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="airFilterSelection.Value && airFilterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (returnAirSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Filter Arrangement:</span>
            <select
              class="halfWidthInputField"
              #returnAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(returnAirSelection.Name)"
              (change)="selectionChanged(returnAirSelection, returnAirInput.value)"
              [value]="returnAirSelection.Value.toString()">
              @for (allowable of returnAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="returnAirSelection.Value && returnAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
